export default __webpack_public_path__ + "static/media/Tick-white.8abcf8fc.svg";